// JavaScript Document
$(document).ready(function(){
	$('#home_carouselle').tinycarousel({ 
        controls: false, 
        pager: false, 
        axis: 'x',
        interval: true,
        intervaltime: 3000,
        duration: 400,
        start: 1,
        display: 1
    });

});